import * as actionTypes from '../actions/ActionTypes';
import CacheMemory from '../helpers/CacheMemory';
import languageManager from '../helpers/Language';

export const RestoreState = (initialState) => {
    initialState.preferences = {
        appLang: languageManager.getLang()
    };
};

export default function setupReducer(rs) {
    rs[actionTypes.SET_APP_LANG] = (prevState, action) => {
        const lang = action.payload;
        if (!languageManager.doesLangExist(lang)) {
            return {...prevState};
        }
        languageManager
            .setLang(lang)
            .saveLang(lang);
        return {
            ...prevState,
            preferences: {
                ...prevState.preferences,
                appLang: lang
            }
        };
    };
}